import React from 'react';
import { Portal } from 'react-portal';
import createReactClass from 'create-react-class';
import Widget from '../common/Widget';
import { Form, AdornedInput, Select, Input } from '../common/Forms';
import ItemAutoComplete from '../common/AutocompleteText';
import DocumentsCollection from '../common/DocumentsCollection';
import itemConfig from '../items/config/itemConfig';
import vendorConfg from '../vendors/config/vendorConfig';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';
import request from '../../helpers/request';
import ButtonToggle from "../common/Forms/ButtonToggle";

const VendorAutoComplete = ItemAutoComplete;

var PurchaseSuggestionWidget = createReactClass({
  getDefaultProps() {
    return {
      onSubmit: '/',
      resetData: null,
      backButtonUrl: '/',
      canSwitchOrderWithoutStorage: false,
    };
  },

  getInitialState() {
    return {
      lines: [],
      newLines: [],
      price: 0,
      orderWithoutStorage: false,
      orderType: 0,
    };
  },

  componentDidMount() {
    this.reset();
  },

  reset() {
    request.get({
      url: this.props.dataUrl,
      success: data => {
        const orderWithoutStorage = data.orderWithoutStorage;
        let lines = data.lines;
        lines.forEach(x => this.initializeItem(x));
        this.setState({
          id: data.id,
          lines: orderWithoutStorage ? [] : lines,
          newLines: orderWithoutStorage ? [] : (data.newLines || []),
          orderWithoutStorage,
          documents: data.documents ||[],
          price: data.price || 0
        }, () => {
          this.initializeNewLinesVendorData();
          this.dataChanged();
        });
      }
    });
  },

  initializeItem(item) {
    if(!item.vendorId) {
      let vendor = item.vendors[0];
      let unit = vendor.purchaseUnits[0];

      item.vendorId = vendor.id;

      this.setItemUnit(item, unit);
      // item.purchaseUnitId = unit.unitId;
      // item.purchaseUnitQuantity = unit.minPurchaseQuantity;
      // item.lineNetPrice = unit.minPurchaseQuantity * unit.netPrice;
    }
  },

  initializeNewLinesVendorData() {
    this.state.newLines.forEach((l, i) => this[`vendorAutocomplete${i}`].setSelection({
      id: l.vendorId,
      name: l.vendorName
    }));
  },

  getSuggestion() {
    return {
      id: this.state.id,
      lines: this.state.lines,
      newLines: this.state.newLines,
      orderWithoutStorage: this.state.orderWithoutStorage,
      price: this.state.price
    };
  },

  handlePurchaseUnitQuantityChange(index, line, purchaseUnitQuantity) {
    line.purchaseUnitQuantity = purchaseUnitQuantity;

    var selectedVendor = line.vendors.find(x => x.id === line.vendorId);
    var selectedUnit = selectedVendor.purchaseUnits
      .find(x => x.unitId === line.purchaseUnitId);

    line.lineNetPrice = Math.round(line.purchaseUnitQuantity * selectedUnit.netPrice * 100) / 100;

    this.changeItem(index, line);
  },

  handleVendorChange(index, line, vendorId) {
    if (! vendorId) {
      return;
    }

    var selectedVendor = line.vendors.find(x => x.id === vendorId);
    var selectedUnit = selectedVendor.purchaseUnits[0]; // TODO Which Unit to default to?

    line.vendorId = selectedVendor.id;
    this.setItemUnit(line, selectedUnit);
    this.changeItem(index, line);
  },

  handlePurchaseUnitChange(index, line, unitId) {
    if (! unitId) {
      return;
    }

    var selectedVendor = line.vendors.find(x => x.id === line.vendorId);
    var selectedUnit = selectedVendor.purchaseUnits.find(x => x.unitId === unitId);

    this.setItemUnit(line, selectedUnit);
    this.changeItem(index, line);
  },

  handleLineNetPriceChange(index, line, lineNetPrice) {
    line.lineNetPrice = lineNetPrice;

    this.changeItem(index, line);
  },

  setItemUnit(line, unit) {
    line.purchaseUnitId = unit.unitId;

    let purchaseUnitQuantity = unit.minPurchaseQuantity;

    while ((purchaseUnitQuantity * unit.stockUnitQuantity) + line.expectedStockQuantity < line.lowStockLimit) {
      purchaseUnitQuantity++;
    }

    line.purchaseUnitQuantity = purchaseUnitQuantity;
    line.lineNetPrice = line.purchaseUnitQuantity * unit.netPrice;
  },

  changeItem(index, line) {
    var newLines = this.state.lines;
    newLines[index] = line;

    this.setState({
      lines: newLines
    }, () => this.dataChanged());
  },

  addExistingItem(item) {
    var matchingLines = this.state.lines.filter(x => x.itemId === item.id);

    if(matchingLines.length === 0) {
      request.get({
        url: purchaseSuggestionConfig.apiUrl + 'new/' + item.id,
        success: item => {
          if (this.isMounted() && (item)) {
            this.initializeItem(item);

            var newLines = this.state.lines.concat([item]);
            this.setState({
              lines: newLines
            }, () => this.dataChanged());
          }
        }
      });
    }
  },

  addNewItem(item) {
    const itemExists = this.state.newLines.findIndex(x => x.itemName === item.name) >= 0;
    if (itemExists) {
      return;
    }

    const newLines = this.state.newLines.concat([{
      itemName: item.name,
      purchaseUnitName: '',
      purchaseUnitQuantity: 1,
      lineNetPrice: 1,
      vendorId: null,
      vendorName: null,
    }]);

    this.setState({
      newLines
    });
  },

  addItem(item) {
    this.addItemSelect.resetSelection();

    if (item.newEntry) {
      this.addNewItem(item);
    } else {
      this.addExistingItem(item);
    }
  },

  removeItem(index) {
    let { lines } = this.state;
    lines.splice(index, 1);
    this.setState({
      lines: lines
    }, () => this.dataChanged());
  },

  clear() {
    this.setState({
      lines: [],
      newLines: [],
    }, () => this.dataChanged());
  },

  getAvailableVendors(line) {
    var availableVendors = line.vendors
      .map(vendor => ({value: vendor.id, label: vendor.vendorName}));

    return availableVendors;
  },

  getAvailableUnits(line) {
    var selectedVendor = line.vendors.find(x => x.id === line.vendorId);

    if(!selectedVendor) {
      return [];
    }

    var availableUnits = selectedVendor.purchaseUnits
      .map(unit => ({ value: unit.unitId, label: unit.name }));

    return availableUnits;
  },

  dataChanged() {
    if(this.form) {
      const requireDocuments = this.state.orderWithoutStorage;
      const isValid = (!requireDocuments || this.state.documents.length > 0) && this.form.state.isValid;
      this.props.onChange({
        itemCount: this.state.lines.length,
        newItemCount: this.state.newLines.length,
        isValid,
        orderWithoutStorage: this.state.orderWithoutStorage
      });
    }
  },

  handleNewLineVendorChange(index, vendor) {
    const newLines = this.state.newLines;
    newLines[index].vendorId = vendor.id;
    newLines[index].vendorName = vendor.name;
    this.setState({newLines}, this.dataChanged);
  },

  handleNewItemPurchaseUnitQuantityChange(index, quantity) {
    const newLines = this.state.newLines;
    newLines[index].purchaseUnitQuantity = quantity;
    this.setState({newLines}, this.dataChanged);
  },

  handleNewItemPurchaseUnitChange(index, puchaseUnitName) {
    const newLines = this.state.newLines;
    newLines[index].puchaseUnitName = puchaseUnitName;
    this.setState({newLines}, this.dataChanged);
  },

  handleNewItemLineNetPriceChange(index, lineNetPrice) {
    const newLines = this.state.newLines;
    newLines[index].lineNetPrice = lineNetPrice;
    this.setState({newLines}, this.dataChanged);
  },

  removeNewItem(index) {
    let { newLines } = this.state;
    newLines.splice(index, 1);
    this.setState({
      newLines
    });
  },

  onDocumentDeleted(document) {
    const documents = this.state.documents;
    const documentIndexToDelete = documents.findIndex(x => x.id === document.id);

    if (documentIndexToDelete >= 0) {
      documents.splice(documentIndexToDelete, 1);
      this.setState({documents}, () => {
        if(documents.length === 0) {
          this.dataChanged();
        }
      });
    }
  },

  onDocumentUploaded(document) {
    const documents = this.state.documents;
    documents.push(document);
    this.setState({documents}, () => {
      if(documents.length === 1) {
        this.dataChanged();
      }
    });
  },

  toggleOrderType(typeIndex) {
    this.setState({ orderType: typeIndex, orderWithoutStorage: typeIndex === 1}, this.dataChanged);
  },

  render() {
    const validateIf = (toCheck, validator) => {
      return toCheck ? validator : null;
    };
    var displayLines = this.state.lines.map((line, index) => {

      const vendorOptions = this.getAvailableVendors(line);
      const purchaseUnitOptions = this.getAvailableUnits(line);

      return(
        <tr key={line.itemId} className="table-row-appear">
          <td className="col-md-2">{line.itemName}</td>
          <td className="col-md-2">
            <Input name={`lines[${index}].itemId`} type="hidden" required value={line.itemId} />
            <Select
              layout="elementOnly"
              name={`lines[${index}].vendorId`}
              id={`lines[${index}].vendorId`}
              options={vendorOptions}
              value={line.vendorId}
              onChange={(elementId, vendorId) => this.handleVendorChange(index, line, vendorId)}
              required
            />
          </td>
          <td className="col-md-1">
            <AdornedInput
              layout="elementOnly"
              name={`lines[${index}].purchaseUnitQuantity`}
              id={`lines[${index}].purchaseUnitQuantity`}
              type="number"
              value={line.purchaseUnitQuantity}
              onChange={(elementId, purchaseUnitQuantity) => this.handlePurchaseUnitQuantityChange(index, line, purchaseUnitQuantity)}
              validations="isMoreThan:0"
              required
            />
          </td>
          <td className="col-md-2">
            <Select
              layout="elementOnly"
              name={`lines[${index}].purchaseUnitId`}
              id={`lines[${index}].purchaseUnitId`}
              options={purchaseUnitOptions}
              value={line.purchaseUnitId}
              onChange={(elementId, purchaseUnitId) => this.handlePurchaseUnitChange(index, line, purchaseUnitId)}
              required
            />
          </td>
          <td className="col-md-1">
            <AdornedInput
              layout="elementOnly"
              name={`lines[${index}].lineNetPrice`}
              id={`lines[${index}].lineNetPrice`}
              type="number"
              addonBefore="€"
              value={line.lineNetPrice}
              validations="isMoreThan:0"
              onChange={(elementId, lineNetPrice) => this.handleLineNetPriceChange(index, line, lineNetPrice)}
              required
            />
          </td>
          <td>
              <a className="btn-sm btn-danger" onClick={() => this.removeItem(index)}><i className="fa fa-remove"></i> </a>
          </td>
        </tr>
      );
    });

    var displayNewLines = this.state.newLines.map((line, index) => {

      return(
        <tr key={line.name} className="table-row-appear">
          <td className="col-md-2">
            <Input name={`newLines[${index}].itemName`} type="hidden" required value={line.itemName} />
            {line.itemName}
          </td>
          <td className="col-md-2">
            <Input name={`newLines[${index}].vendorId`} type="hidden" required value={line.vendorId || ''} />
            <Input name={`newLines[${index}].vendorName`} type="hidden" required value={line.vendorName || ''} />
            <VendorAutoComplete
              ref={c => this[`vendorAutocomplete${index}`] = c}
              dataUrl={vendorConfg.vendorsFastSearchUrl}
              onSelect={vendor => this.handleNewLineVendorChange(index, vendor)}
              searchPlaceholder="Lieferant hinzufügen"
              idProp="id"
              displayProp="name"
              noMatchesText="Kein Ergebnis"
              searchInProgressText="Suche..."
            />
          </td>
          <td className="col-md-1">
            <AdornedInput
              layout="elementOnly"
              name={`newLines[${index}].purchaseUnitQuantity`}
              id={`newLines[${index}].purchaseUnitQuantity`}
              type="number"
              value={line.purchaseUnitQuantity}
              onChange={(elementId, purchaseUnitQuantity) => this.handleNewItemPurchaseUnitQuantityChange(index, purchaseUnitQuantity)}
              validations="isMoreThan:0"
              required
            />
          </td>
          <td className="col-md-2">
            <AdornedInput
              layout="elementOnly"
              name={`newLines[${index}].purchaseUnitName`}
              id={`newLines[${index}].purchaseUnitName`}
              type="text"
              value={line.purchaseUnitName}
              onChange={(elementId, purchaseUnitName) => this.handleNewItemPurchaseUnitChange(index, purchaseUnitName)}
            />
          </td>
          <td className="col-md-1">
            <AdornedInput
              layout="elementOnly"
              name={`newLines[${index}].lineNetPrice`}
              id={`newLines[${index}].lineNetPrice`}
              type="number"
              addonBefore="€"
              value={line.lineNetPrice}
              validations="isMoreThan:0"
              onChange={(elementId, lineNetPrice) => this.handleNewItemLineNetPriceChange(index, lineNetPrice)}
              required
            />
          </td>
          <td>
              <a className="btn-sm btn-danger" onClick={() => this.removeNewItem(index)}><i className="fa fa-remove"></i> </a>
          </td>
        </tr>
      );
    });

    const allowNewItemEntry = !this.state.orderWithoutStorage;
    const fileApiBaseUrl = !!this.props.suggestionId ? `${purchaseSuggestionConfig.apiUrl}${this.props.suggestionId}` : `${purchaseSuggestionConfig.apiUrl}new`;

    const artikelTableClass = this.state.orderWithoutStorage ? "table-responsive hidden" : "table-responsive";
    const bestellSummeClass = !this.state.orderWithoutStorage ? "hidden" : "";
    return (
      <div>
        { this.props.canSwitchOrderWithoutStorage &&
          <div style={{marginBottom: '10px'}} className="col-md-12">
            <ButtonToggle value={this.state.orderType} options={['Mit Lagerführung', 'Ohne Lagerführung']}
                          onSelect={this.toggleOrderType}/>
          </div>
        }
        <Widget title={this.props.title} icon="file-archive-o" bodyClassName="min-height-auto">

          <Form ref={c => this.form = c}
            onSubmit={data => this.props.onSubmit(data, this.state.documents)}
            onValidate={this.dataChanged}
            footer={this.props.footer}>
            <div style={{ padding: '10px' }} className={bestellSummeClass}>
              <label>Bestellsumme:
                <AdornedInput
                  name="orderSumme"
                  id="orderSumme"
                  type="number"
                  value={this.state.price}
                  onChange={(_, price) => this.setState({price}, () => this.dataChanged())}
                  addonBefore="€"
                  validations={validateIf(this.props.orderWithoutStorage, "isMoreThan:0")}
                  required
                />
              </label>
            </div>
            <div className={artikelTableClass}>
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Artikel</th>
                            <th>Lieferant</th>
                            <th>Bestellmenge</th>
                            <th>Bestelleinheit</th>
                            <th>Preis</th>
                            <th>Aktionen</th>
                        </tr>
                    </thead>
                    <tbody>
                        {displayLines}
                        {displayNewLines}
                        <tr>
                          <td style={{padding: 5}} key={allowNewItemEntry}>
                            <ItemAutoComplete
                                allowNewEntries={allowNewItemEntry}
                                ref={c => this.addItemSelect = c}
                                dataUrl={itemConfig.itemsFastSearchUrl}
                                onSelect={this.addItem}
                                searchPlaceholder="Artikel zum Bestellvorschlag hinzufügen"
                                idProp="id"
                                displayProp="name"
                                noMatchesText="Kein Ergebnis"
                                searchInProgressText="Suche..."
                                staticQueryParams={{onlyWithVendor: true}}
                              />
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </Form>
        </Widget>
        <Portal node={document && document.getElementById(this.props.documentsNodeId)}>
          <div className="row">
            <div className="col-md-12">
              <DocumentsCollection
                documents={this.state.documents}
                onDoumentDeleted={this.onDocumentDeleted}
                onDocumentUploaded={this.onDocumentUploaded}
                deleteUrlBase={fileApiBaseUrl}
                viewUrlBase={fileApiBaseUrl}
                uploadUrlBase={fileApiBaseUrl}
                claim={this.props.claim}
              />
            </div>
          </div>
        </Portal>
      </div>
    );
  }

});

export default PurchaseSuggestionWidget;



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/PurchaseSuggestionWidget.js